export default {
    app: {
        name: "H-D Service Information Portal",
        initErrorTitle: "Unable to connect",
        initErrorDescription: "There was an error connecting to H-D Service Information Portal. This may be a temporary issue so try again in a few moments.",
        siteDownTitle: "We'll be back soon!",
        siteDownDescription: "H-D Service Information Portal is currently undergoing maintenance and will be back shortly.",
        updateAvailable: "An update is available. The page will reload to complete the installation.",
        updateNow: "Update Now",
        offlineBanner: "You are offline. Connect to the internet to enable all features."
    },
    auth: {
        logInButton: "Log In",
        loggedOut: "You have been logged out. Please log in to continue.",
        needLogIn: "You need to log in to continue.",
        logInError: "There was an error logging in.",
        ssoError: "An error occurred during the authentication process, please try authenticating again. If the problem persists, please contact support."
    },
    sidebar: {
        logIn: "Log In",
        register: "Register",
        searchByVin: "Search",
        vehicleLookup: "Vehicle Lookup",
        menuButton: "Menu",
        searchButton: "Search",
        helpButton: "Help",
        messagesButton: "Inbox",
        accountButton: "Account",
        expandButton: "Expand Sidebar",
        collapseButton: "Collapse Sidebar",
        showSidebar: "Show Sidebar",
        backToVehicle: function anonymous(arg0) {
            return "Back to ".concat(arg0);
        },
        backToOldLook: "Back to Old Look"
    },
    header: {
        help: "Help",
        messages: "Inbox",
        unreadMessages: function anonymous(arg0) {
            return "".concat(arg0, " unread messages");
        },
        account: "Account",
        accountDetails: "Account Details",
        subscriptions: "Subscriptions",
        logOut: "Log Out",
        administration: "Administration",
        authoring: "Authoring"
    },
    footer: {
        privacy: "Privacy",
        terms: "Terms",
        cookies: "Cookies",
        contact: "Contact",
        about: "About",
        applicationNameLabel: "Application name",
        itisVersionLabel: "ITIS version",
        copyright: function anonymous(arg0) {
            return "\u00A9 ".concat(arg0, " Harley-Davidson Motor Company, Inc.");
        }
    },
    welcome: {
        title: "Home",
        authorisedDealers: {
            title: "Authorized Dealers",
            description: "Authorized dealers click here to login via SSO.",
            button: "Authorized Dealer Login"
        },
        independentOperators: {
            title: "Independent Operators",
            description: "Independent Operators who have a registered account click here to login.",
            button: "Independent Operator Login"
        },
        customerLookup: {
            title: "Customer VIN or Instruction Sheet Look-up",
            description: "Click here to use a valid 17 character VIN to find limited Service information without registering or search for instruction sheets.",
            button: "Search"
        },
        register: {
            title: "Register For Access",
            description: "Welcome to H-D Service Information Portal. To preview the range of information available on the site, you may register by clicking the button. Some information is available free of charge. Subscriptions to access additional service information may be purchased by Independent Operators.",
            button: "Register"
        },
        newLook: {
            title: "Welcome to the New Look",
            description: "Use the link in the sidebar to switch back at any time.",
            button: "Back to Old Look"
        },
        cannotLogInOffline: "Unable to log in as you are offline.",
        cannotRegisterOffline: "Unable to register as you are offline."
    },
    notices: {
        title: "Notices",
        loadError: "Unable to load notices",
        emptyList: "No notices",
        showAll: "Show All Notices",
        noticeColumn: "Notice",
        dateColumn: "Date"
    },
    notice: {
        title: "Notice",
        loadError: "Unable to load notice",
        notFound: "Notice not found",
        titleLabel: "Title",
        dateLabel: "Date"
    },
    importantDocuments: {
        title: "Recent Important Documents",
        loadError: "Unable to load important documents",
        emptyList: "No important documents",
        notLoggedIn: "You must be logged in to view the recent important documents list."
    },
    frequentlyUsedDocuments: {
        title: "Frequently Used Documents",
        loadError: "Unable to load frequently used documents",
        emptyList: "No frequently used documents"
    },
    vehicleLookup: {
        title: "Vehicle Lookup",
        findVehicleTitle: "Select a Vehicle",
        enterVin: "Enter a VIN (for model years 1981-present):",
        enterVinAsGuest: "Enter a VIN:",
        chooseVehicle: "Choose a vehicle:",
        viewAllDocuments: "Click 'View All' to see all available documents.",
        findButton: "Find",
        chooseButton: "Choose",
        viewAllButton: "View All",
        showProductSelect: "Don't know the VIN?",
        vinNotFound: "VIN not found",
        vinNotFoundTryModelSelection: "VIN not found. Try a different one or use the model selection below.",
        findError: "There was an error finding vehicles",
        selectProduct: "- Please select -",
        selectOptionalProduct: "- Please select (optional) -",
        selectYear: "- Select a year (optional) -",
        noProductSelected: "None",
        loadingProducts: "Loading...",
        loadProductsError: "Error loading items",
        multipleVinMatch: "More than one VIN matched your search, please enter the full 17 character VIN",
        selectVinTitle: "Choose Vehicle",
        selectVinMessage: "More than one VIN matched your search. Please select the VIN you wish to look up.",
        incorrectVinDialogueTitle: "Incorrect VIN",
        incorrectVinDialogueMessage: "Incorrect VIN format. 6 digits need to input after hyphen."
    },
    vehicleHistory: {
        favouritesTitle: "Favorite Lookups",
        recentsTitle: "Recent Lookups",
        showAllFavourites: "Show All Favorite Lookups",
        showAllRecents: "Show All Recent Lookups",
        noFavourites: "You do not have any favorite lookups.",
        noRecents: "You do not have any recent lookups.",
        loadError: "There was an error loading vehicle history."
    },
    vehiclePlateRecognition: {
        title: "Provide a photograph of the VIN",
        notRecognised: "VIN not recognised in image. Please try another image or enter the VIN manually.",
        wrongFileFormat: "Wrong file format. File should be an image.",
        serviceError: "Something went wrong. Please try again and if the problem persists enter the VIN manually."
    },
    vehicle: {
        title: "Vehicle Information",
        loadError: "There was an error loading this vehicle",
        notFound: "Vehicle not found",
        addFavouriteButton: "Add to favorites",
        removeFavouriteButton: "Remove from favorites",
        addedFavourite: "This vehicle has been added to your favorites.",
        removedFavourite: "This vehicle has been removed from your favorites.",
        errorAddingFavourite: "There was an error adding this vehicle to your favorites.",
        errorRemovingFavourite: "There was an error removing this vehicle from your favorites",
        removeRecentLookupButton: "Remove from recent lookups",
        removedRecentLookup: "This vehicle has been removed from your recent lookups",
        errorRemovingRecentLookup: "There was an error removing this vehicle from your recent lookups",
        vinLabel: "VIN",
        modelYearLabel: "Product Year",
        modelNameLabel: "Model",
        modelCodeLabel: "Code",
        modelBuildDateLabel: "Build Date",
        modelEngineSerialNumberLabel: "Engine Serial Number",
        modelSaleDateLabel: "Sale Date",
        modelSellerDealerCodeLabel: "Seller Dealer Code",
        modelWarrantyEndDateLabel: "Warranty End Date",
        modelWarrantyStartDateLabel: "Warranty Start Date",
        imageAlt: "Vehicle",
        imageCaption: "Image for illustration purposes only",
        noImage: "Vehicle image not available",
        purchaseSubscription: "Purchase subscriptions",
        featuresTitle: "Vehicle Features",
        overviewTab: "Overview",
        featuresTab: "Features",
        linksTab: "Links",
        vehicleToggleInstruction: "Show vehicle information",
        changeVinButton: "Change VIN",
        additionalVinButton: "Additional VIN",
        currentVinTitle: "Current VIN:",
        changeVehicleButton: "Change Vehicle",
        additionalVehicleButton: "Additional Vehicle",
        currentModelTitle: "Current Model:"
    },
    links: {
        loadError: "Unable to load links",
        exitWarningTitle: "Leaving Site",
        exitWarningPara1: "You have clicked on a link to an external site, the content of which may not be controlled by us. The link will open in a new tab in your web browser and your session will remain active in this tab.",
        exitWarningPara2: "Click Open Link if you still wish to visit the external site, or Cancel to prevent the site from opening.",
        exitWarningConfirmButton: "Open Link"
    },
    suggestVinLookup: {
        title: "Search By Model",
        content: "We recommend searching for your vehicle using the chassis number (VIN). Searching using the model search may result in multiple documents being presented.",
        searchByVinButton: "Search By Vin",
        acknowledgeButton: "I Understand"
    },
    documentGroupLookup: {
        title: "Search via Document Group",
        helpText: "Select document group from menu below to show all entries.",
        selectDocumentGroupItem: "- Please select a Document Group -",
        selectButton: "Select",
        loadError: "There was an error loading document groups",
        emptyList: "No document groups to search by"
    },
    documentGroups: {
        expand: "Expand Group",
        collapse: "Collapse Group",
        loadError: "There was an error loading document groups"
    },
    documentGroup: {
        loadError: "There was an error loading this document group",
        notFound: "Document group not found",
        emptyList: "No documents",
        filterPlaceholder: "Filter documents",
        titleColumn: "Title",
        pageTitleColumn: "Page Title",
        referenceColumn: "Global Reference",
        publicationDateColumn: "Publication Date",
        notInLanguage: function anonymous(arg0) {
            return "Not available in ".concat(arg0);
        },
        viewInAnotherLanguage: "View in another language",
        viewInLanguage: function anonymous(arg0) {
            return "View in ".concat(arg0);
        },
        availableLanguageCount: function anonymous(arg0) {
            return "".concat(arg0, " available");
        },
        availableInLanguages: {
            one: "Available in 1 language",
            other: function anonymous(arg0) {
                return "Available in ".concat(arg0, " languages");
            }
        },
        availableInOtherLanguages: {
            one: "Available in 1 other language",
            other: function anonymous(arg0) {
                return "Available in ".concat(arg0, " other languages");
            }
        }
    },
    favouriteContent: {
        title: "Favorite Content",
        loadError: "Unable to load favorite content",
        emptyList: "No favorite content",
        showAll: "Show All Favorite Content",
        showPages: "Show Pages",
        hidePages: "Hide Pages"
    },
    favouriteDocuments: {
        title: "Favorite Documents",
        loadError: "Unable to load favorite documents",
        emptyList: "No favorite documents",
        showAll: "Show All Favorite Documents"
    },
    serviceHistory: {
        title: "Service History",
        loadError: "Unable to load service history",
        lastService: "Last Service",
        nextServiceDue: "Next Service Due",
        never: "Never",
        none: "None",
        type: function anonymous(arg0) {
            return "Type: ".concat(arg0);
        }
    },
    serviceRecords: {
        submitError: "There was a problem submitting this service record."
    },
    document: {
        loadError: "Error loading document",
        notFound: "Document not found",
        editButton: "Edit",
        feedbackButton: "Feedback",
        infoButton: "Info",
        attachmentsButton: "Attachments",
        printPreviewButton: "Print PDF",
        maximiseButton: "Maximize",
        addFavouriteButton: "Add to favorites",
        removeFavouriteButton: "Remove from favorites",
        favouriteButton: {
            addDocument: "Add document to favorites",
            removeDocument: "Remove document from favorites",
            addFragment: "Add page to favorites",
            removeFragment: "Remove page from favorites"
        },
        addedFavouriteDocument: "This document has been added to your favorites.",
        removedFavouriteDocument: "This document has been removed from your favorites.",
        addedFavouriteFragment: "This page has been added to your favorites.",
        removedFavouriteFragment: "This page has been removed from your favorites.",
        errorAddingFavouriteDocument: "There was an error adding this document to your favorites.",
        errorRemovingFavouriteDocument: "There was an error removing this document from your favorites",
        errorAddingFavouriteFragment: "There was an error adding this page to your favorites.",
        errorRemovingFavouriteFragment: "There was an error removing this page from your favorites",
        watchButton: "Watch",
        downloadButton: "Download",
        latestVersionDocumentButton: "Latest Version Document",
        unwatchButton: "Unwatch",
        shareButton: "Share Link",
        startedWatching: "You are now watching this document and will be notified when it is updated.",
        stoppedWatching: "You are no longer watching this document and will not be notified when it is updated.",
        errorWatching: "There was an error watching this document.",
        errorUnwatching: "There was an error unwatching this document.",
        printButton: "Print HTML",
        searchPlaceholder: "Search document",
        cannotEdit: "You cannot edit this document.",
        cannotEditOffline: "Unable to edit this document as you are offline.",
        cannotOpenOffline: "Unable to open this document as you are offline.",
        downloadingInSeconds: {
            one: "This document will start downloading in 1 second.",
            other: function anonymous(arg0) {
                return "This document will start downloading in ".concat(arg0, " seconds.");
            }
        },
        downloadingNow: "This document is now downloading.",
        downloadNow: "Download Now",
        backToSearch: "Back to Search Results",
        subscriptionRequiredTitle: "Subscription Required",
        subscriptionRequired: "You do not have a valid subscription to view this content.",
        labels: {
            draft: "Draft",
            embargoed: "Embargoed",
            new: "New"
        },
        notAuthorised: "Not Authorized",
        notAuthorisedTitle: "Sorry, you are not authorized to view this document.",
        notAuthorisedText: "If you believe you should be able to view this document please contact us.",
        notIndexed: "Not Indexed",
        notIndexedTitle: "The document has not yet been indexed.",
        notIndexedText: "Please try again in a few minutes.",
        notAuthenticated: "Not Authenticated",
        notAuthenticatedText: "Please login if you already have an account with the required permissions.",
        coverPageError: "Unable to load cover page for this document.",
        embargoedUntilDate: function anonymous(arg0) {
            return "Embargoed until ".concat(arg0);
        },
        latestVersionDocumentWarning: "This document has been removed, its content may be out of date.",
        showMoreText: "Show more",
        showLessText: "Show less"
    },
    documentAttachments: {
        title: "Attachments",
        noAttachments: "No attachments found",
        loadError: "Error fetching attachments",
        downloadError: "Error downloading attachment"
    },
    documentInfo: {
        title: "Document Details",
        titleLabel: "Title",
        referenceLabel: "Global Reference",
        sourceIdLabel: "Source ID",
        pathLabel: "Navigation Paths",
        dateLabel: "Publication Date",
        embargoedUntilLabel: "Embargoed Until",
        notPublished: "Not Published",
        editDocument: "Edit Document",
        viewApplicabilities: "View Applicabilities",
        cannotViewApplicabilitiesOffline: "Unable to view applicabilities for this document as you are offline.",
        viewHistory: "View History"
    },
    documentHistory: {
        title: "Publication History",
        tableTitle: "Publication History Table",
        publicationDateLabel: "Publication Date",
        sourceVersionLabel: "Source Version",
        globalReferenceLabel: "Global Reference",
        emptyList: "No publication history",
        loadError: "Unable to load publication history"
    },
    documentFeedback: {
        title: "Document Feedback",
        descriptionLine1: function anonymous(arg0) {
            return "You may provide feedback on the quality of \"".concat(arg0, "\" by filling in the form below.");
        },
        descriptionLine2: "Your email address is shown for reference purposes only. This address could be used in the event a reviewer wants to contact you regarding your feedback.",
        charactersRemaining: {
            one: "1 character remaining",
            other: function anonymous(arg0) {
                return "".concat(arg0, " characters remaining");
            }
        },
        charactersOver: {
            one: "1 character over",
            other: function anonymous(arg0) {
                return "".concat(arg0, " characters over");
            }
        },
        sendButton: "Send Feedback",
        sendSuccess: "Your feedback has been sent.",
        sendFailure: "There was an error sending your feedback.",
        logInRequired: "You must be logged in to send feedback.",
        errorLoadingDocument: "There was an error loading this document.",
        nameField: "Name",
        emailField: "Email",
        fileField: "File",
        commentsField: "Comments",
        nameRequiredError: "Name is required",
        commentsRequiredError: "Comments are required",
        imageUploadExceededMaximumSizeError: "The provided image exceeds the maximum file size of 5MB, choose a smaller file.",
        commentsLengthError: function anonymous(arg0) {
            return "Comments must be less than ".concat(arg0, " characters");
        },
        receiveCopy: "Receive a copy of your feedback"
    },
    documentResolver: {
        errorTitle: "Unable to look up document",
        missingQuery: "A query (**sourceId**, **globalReferenceNumber** or **reference** parameter) or **tags** parameter must be provided.",
        invalidQuery: "Only one of **sourceId**, **globalReferenceNumber** or **reference** parameters can be provided.",
        invalidVehicle: "Cannot provide both **vin** and **modelCode** parameters.",
        multipleDocuments: "More than one document was found."
    },
    documentShareLink: {
        linkCopiedButton: "Link Copied",
        copyLinkButton: "Copy Link",
        copyLinkError: "An error occurred while copying the link.",
        shareLinkDescription: "Please note if you are sharing this link with someone else they may not have permission to view this document.",
        userSuggestionDescription: "Send link to one or more users. Start typing below to see suggestions.",
        successMessage: "The link has been sent to all of the selected parties.",
        messageLabel: "Message:",
        noUsersMessage: "Please select one or more users.",
        submitError: "There was an error sending share link.",
        applicableFetchError: "There was an error checking applicability",
        shareLinkEmptyError: "Share link cannot be empty",
        userNotEligibleError: "You cannot send this link to one or more users (highlighted red) as they do not have the appropriate permissions. Please remove those in red for the link to be sent successfully.",
        shareLinkField: "Share Link",
        messageField: "Message",
        logInRequired: "You must be logged in to share a document.",
        usersAutocompleteLabel: "Users"
    },
    documentSearch: {
        pageTitle: function anonymous(arg0) {
            return "Search Results for \"".concat(arg0, "\"");
        },
        title: "Search Results",
        searchedAll: function anonymous(arg0) {
            return "Searched all documents for \"".concat(arg0, "\"");
        },
        searchedVehicle: function anonymous(arg0, arg1) {
            return "Searched ".concat(arg1, " for \"").concat(arg0, "\"");
        },
        searchError: "There was an error searching documents",
        noResults: "No documents were found for this search",
        searchDocuments: "Search documents",
        clearSearch: "Clear Search",
        searchIn: "Search In",
        searchTitles: "Titles",
        searchDescriptions: "Descriptions",
        searchContents: "Contents",
        allDocuments: "All Documents",
        querySuggestion: function anonymous(arg0, arg1) {
            return "Did you mean [**".concat(arg0, "**](").concat(arg1, ")?");
        },
        invalidQuery: "It looks like you tried to search using an invalid advanced query, so your search was performed as a simple query instead. Use the help link above for more information on advanced querying.",
        helpButton: "Search Options Help",
        helpDialogue: {
            title: "Search Tips",
            searchOptionsTitle: "Search Options",
            advancedSearchingTitle: "Advanced Search Wildcards and Operators",
            advancedSearchingTip: "TIP! Use the search operators to achieve more accurate search results",
            boxes: {
                searchVehicleTerm: "Name (VIN)",
                searchVehicle: "Restrict your search to this vehicle/product",
                searchTitles: "Search document titles",
                searchDescriptions: "Search document descriptions",
                searchContents: "Search document contents"
            },
            table: {
                title: "Advanced Search Wildcards and Operators Table",
                operators: "Operators",
                examples: "Examples",
                results: "Results",
                content: {
                    and: {
                        operator: "&& (and)",
                        example: "term-1 && term-2",
                        result: "Documents that include both term-1 and term-2"
                    },
                    not: {
                        operator: "! (not)",
                        example: "!term-1",
                        result: "Documents that don't include term-1"
                    },
                    wildcard: {
                        operator: "* (wildcard)",
                        example: "term-*",
                        result: "Documents that include term-1, term-2, term-*"
                    }
                }
            }
        },
        cannotSearchOffline: "You are offline. Connect to the internet to search for documents."
    },
    documentFilter: {
        filter: "Filter",
        filterResults: "Filter results",
        clearFilter: "Clear filter",
        onlyEmbargoed: "Only embargoed",
        hideEmbargoed: "Hide embargoed",
        onlyShowEmbargoedDocuments: "Only show embargoed documents",
        hideEmbargoedDocuments: "Hide embargoed documents",
        filterByPublicationDate: "Filter by publication date",
        publishedOnOrAfter: "Published On or After",
        publishedOnOrBefore: "Published On or Before",
        publishedOnOrAfterDate: function anonymous(arg0) {
            return "Published On or After ".concat(arg0);
        },
        publishedOnOrBeforeDate: function anonymous(arg0) {
            return "Published On or Before ".concat(arg0);
        },
        showCalendar: "Show calendar",
        showYears: "Show years",
        nextMonth: "Next month",
        previousMonth: "Previous month"
    },
    documentSidebar: {
        showSidebar: "Show Document Sidebar",
        expandButton: "Expand Document Sidebar",
        collapseButton: "Collapse Document Sidebar",
        relatedDocuments: "Related Documents"
    },
    messages: {
        title: "Inbox",
        loadError: "Unable to load messages",
        emptyList: "No messages",
        filterPlaceholder: "Filter messages",
        selectedCount: function anonymous(arg0) {
            return "".concat(arg0, " selected");
        },
        fromColumn: "From",
        subjectColumn: "Subject",
        dateColumn: "Date",
        markAsReadButton: "Mark as Read",
        markAsReadError: "Unable to mark messages as read.",
        markAsUnreadButton: "Mark as Unread",
        markAsUnreadError: "Unable to mark messages as unread.",
        deleteButton: "Delete",
        deleteConfirmationTitle: "Confirm Delete",
        deleteConfirmationMessage: {
            one: "Are you sure you want to delete this message?",
            other: function anonymous(arg0) {
                return "Are you sure you want to delete ".concat(arg0, " messages?");
            }
        },
        deletedMessages: {
            one: "Deleted 1 message.",
            other: function anonymous(arg0) {
                return "Deleted ".concat(arg0, " messages.");
            }
        },
        deleteError: "Unable to delete messages.",
        markAllAsReadButton: "Mark all messages as read",
        markAllAsReadConfirmationTitle: "Confirm marking messages as read",
        markAllAsReadConfirmationMessage: "Are you sure you want to mark all the unread messages as read?",
        markAllAsReadError: "Unable to mark all messages as read."
    },
    message: {
        loadError: "Unable to load message",
        notFound: "Message not found",
        subjectLabel: "Subject",
        fromLabel: "From",
        dateLabel: "Date",
        backToMessages: "Back to Messages"
    },
    account: {
        title: "Account",
        accountDetailsTab: "Account Details",
        twoFactorAuthTab: "Two-factor Authentication",
        changePasswordTab: "Change Password",
        changeEmailTab: "Change Email",
        preferencesTab: "Preferences",
        subscriptionsTab: "Subscriptions",
        deleteAccountTab: "Delete Account",
        legalRepresentativeTab: "Legal Representative",
        loadError: "There was an error loading account details."
    },
    accountDetails: {
        personalTitle: "Personal",
        businessTitle: "Business",
        addressTitle: "Address",
        optional: "Optional",
        readOnly: "Read-Only",
        submitButton: "Save Changes",
        saving: "Saving...",
        saveSuccess: "Your account details have been updated.",
        saveError: "There was an error updating your account details.",
        formErrors: "There are form errors.",
        firstName: {
            label: "First name",
            required: "First name is required",
            length: function anonymous(arg0) {
                return "First name must be a maximum of ".concat(arg0, " characters.");
            }
        },
        lastName: {
            label: "Last name",
            required: "Last name is required",
            length: function anonymous(arg0) {
                return "Last name must be a maximum of ".concat(arg0, " characters.");
            }
        },
        jobTitle: {
            label: "Job title",
            length: function anonymous(arg0) {
                return "Job title must be a maximum of ".concat(arg0, " characters.");
            }
        },
        isBusiness: {
            label: "I am using this site for business purposes"
        },
        companyName: {
            label: "Company name",
            required: "Company name is required",
            length: function anonymous(arg0) {
                return "Company name must be a maximum of ".concat(arg0, " characters.");
            }
        },
        vatNumber: {
            label: "VAT number",
            length: function anonymous(arg0) {
                return "VAT number must be a maximum of ".concat(arg0, " characters.");
            }
        },
        companyRegNumber: {
            label: "Company registration number",
            length: function anonymous(arg0) {
                return "Company registration number must be a maximum of ".concat(arg0, " characters.");
            }
        },
        dealerNumber: {
            label: "Dealer number"
        },
        addressLine1: {
            label: "Address",
            required: "Address is required",
            length: function anonymous(arg0) {
                return "Address line must be a maximum of ".concat(arg0, " characters.");
            }
        },
        addressLine2: {
            label: "Address line 2",
            length: function anonymous(arg0) {
                return "Address line must be a maximum of ".concat(arg0, " characters.");
            }
        },
        addressLine3: {
            label: "Address line 3",
            length: function anonymous(arg0) {
                return "Address line must be a maximum of ".concat(arg0, " characters.");
            }
        },
        town: {
            label: "Town or city",
            required: "Town or city is required",
            length: function anonymous(arg0) {
                return "Town or city must be a maximum of ".concat(arg0, " characters.");
            }
        },
        region: {
            label: "Region or state",
            length: function anonymous(arg0) {
                return "Region must be a maximum of ".concat(arg0, " characters.");
            },
            required: "Region or state is required"
        },
        postCode: {
            label: "Post code or zip code",
            required: "Post code or zip code is required",
            length: function anonymous(arg0) {
                return "Post code must be a maximum of ".concat(arg0, " characters.");
            }
        },
        phone: {
            label: "Telephone",
            required: "Telephone is required",
            numbersOnly: "Please enter numbers only (no dashes, no special characters)",
            length: function anonymous(arg0) {
                return "Phone must be a maximum of ".concat(arg0, " characters.");
            }
        },
        country: {
            label: "Location"
        }
    },
    changePassword: {
        title: "Change your password",
        lengthHint: "Your password should be between 8-255 characters.",
        submitButton: "Change Password",
        saving: "Saving...",
        saveSuccess: "Your password has been changed.",
        saveError: "There was an error changing your password.",
        formErrors: "There are form errors.",
        currentPassword: {
            label: "Current password",
            required: "Current password is required",
            length: "Password must be between 8 and 255 characters"
        },
        newPassword: {
            label: "New password",
            required: "New password is required",
            length: "New password must be between 8 and 255 characters",
            same: "New password is the same as current password"
        },
        confirmPassword: {
            label: "Confirm new password",
            mismatch: "Passwords do not match"
        }
    },
    changeEmail: {
        title: "Change your email",
        currentEmail: "Current email",
        newEmail: {
            label: "New email",
            required: "New email is required",
            valid: "New email is not valid",
            different: "New email should be different than current"
        },
        newEmailConfirmation: {
            label: "Confirm new email",
            required: "New email confirmation is required",
            valid: "Confirmed email must be valid",
            same: "Confirmed email must be the same"
        },
        password: {
            label: "Password",
            required: "Password is required",
            length: "Password must be between 8 and 255 characters"
        },
        saveError: "There was an error changing your email.",
        formErrors: "Please check validation errors",
        saveSuccess: "Save success",
        saving: "Saving",
        submitButton: "Submit",
        emailAwaitingVerification: {
            label: "Email awaiting verification"
        },
        verificationExpectedNotice: "Your requested email address change is awaiting verification: a verification link has been sent to the new email address, and you must use this link to verify the change. The link will be valid for 24 hours.",
        sendAnotherVerificationButton: {
            text: "Send another verification email",
            loadingText: "Sending...",
            successText: "The verification email has been resent",
            errorText: "An error occurred"
        },
        cancelEmailVerificationButton: {
            text: "Cancel email change",
            loadingText: "Cancelling...",
            successText: "The email change was cancelled",
            errorText: "An error occurred"
        }
    },
    preferences: {
        emailTitle: "Email",
        languageTitle: "Language and country",
        submitButton: "Save Changes",
        saving: "Saving...",
        saveSuccess: "Your preferences have been updated.",
        saveError: "There was an error updating your preferences.",
        formErrors: "There are form errors.",
        inboxEmails: {
            label: "Receive emails for message inbox",
            description: "This will ensure that you receive all notifications about updates to documents or newly published documents in your email as well as via the messages inbox."
        },
        marketingInfo: {
            label: "Receive marketing information"
        },
        language: {
            label: "Language"
        },
        country: {
            label: "Location"
        }
    },
    legalRepresentativeForm: {
        title: "Legal Representative",
        descriptionLine1: "As the nominated Legal Representative of your company, you have the ability to invite or remove Employee accounts within your company.",
        descriptionLine2: "To invite a new Employee, simply type their email address in the input field and click save changes at the bottom of the page. Alternatively, if you have multiple accounts to invite, simply copy paste them into the input field.",
        submitButton: "Submit",
        saveSuccess: "Invitations have been sent.",
        saveError: "There was an error updating your legal representatives.",
        email: {
            header: "Add Independent Repairer Employee",
            label: "Email addresses",
            required: "At least one email address is required.",
            valid: "Some emails are not valid.",
            haveLegalRepresentative: "These accounts already have legal representatives:"
        }
    },
    legalEmployeesPanel: {
        header: "Your Employees",
        tableTitle: "Legal Employees Table",
        description: "Below is a list of Employees that have accepted your invitations.",
        empty: "You are not currently representing any employees",
        emailAddress: "Email address",
        disabledStatus: "Disabled",
        employeeStatusSwitch: "Switch employee status",
        loadError: "Unable to load employees",
        changeStatusError: "There was an error updating your employee status"
    },
    deleteAccount: {
        title: "Delete your account",
        warning: "Warning:",
        description: "Deleting your account is permanent and you will lose access to any subscriptions that you have purchased and any other data associated with your account.",
        deleteButton: "Delete Account",
        confirmLine1: "Are you sure you want us to close your account, and delete all the personal data we hold about you? If you have any active subscriptions you will no longer be able to access them.",
        confirmLine2: "Please be aware that in order to comply with financial regulations, this action will not affect storage of any invoices that contain your data which will be stored for up to 7 years.",
        confirmLine3: "Enter your user name or email address to confirm that you wish to delete your account. There is no way to undo this action if you proceed.",
        userNameOrEmailLabel: "User name or email address",
        userNameOrEmailRequired: "User name or email address is required.",
        userNameOrEmailIncorrect: "User name or email address is incorrect.",
        disabledPageTitle: "Account Disabled",
        disabledTitle: "Account Disabled Successfully",
        disabledLine1: "Your account has been disabled with immediate effect. We will remove all of your personal data from our databases within 30 days. Your data will be destroyed from any backups as part of the restoration process.",
        disabledLine2: "If you would also like your data to be removed from all other H-D Service Information Portal systems please email HDMC-SipSupport@harley-davidson.com."
    },
    twoFactorAuth: {
        methods: {
            title: "Authentication methods",
            description: "Two-factor authentication provides you with a one-time password that you can use when logging in using a new browser or device, this protects your account from being compromised if someone finds out or guesses your password.",
            authenticatorApp: "Authenticator App",
            email: "Email",
            enabled: "Enabled",
            disabled: "Disabled",
            enable: "Enable",
            disable: "Disable",
            registerNewApp: "Register New App"
        },
        trustedDevices: {
            title: "Trusted devices",
            description: "You will not need to use your two-factor code when logging in with trusted devices for up to 90 days.",
            lastLogin: "Last Login",
            trustedUntil: "Trusted Until",
            emptyList: "You have not trusted any devices.",
            deleteTitle: "Delete Trusted Device",
            deleteMessage: "Are you sure you want to delete this trusted device? You will need to enter your two-factor code when you next log in with this device.",
            deleteButton: "Delete Device",
            deleteError: "Unable to delete trusted device.",
            deletedMessage: "Trusted device removed successfully."
        }
    },
    register: {
        title: "Register",
        selectUserType: "Select your user type",
        operatorType: {
            title: "NSC/Distributor/Manufacturer",
            description: "You are an employee of Harley-Davidson or one of its subsidiaries, or a distributor of Harley-Davidson."
        },
        legalRepresentativeType: {
            title: "Independent Operator Legal Representative",
            description: "You are a General Manager, Dealer Principal, or someone who takes responsibility for the actions of employees at the independent workshop you work at. You can add accounts for other unnamed technicians at your organisation. There needs to be at least one legal representative at an organisation to gain access to this site."
        },
        employeeType: {
            title: "Independent Operator Employee",
            description: "You are a technician working at an independent workshop and have had an account created by a legal representative at your organisation."
        },
        individualType: {
            title: "Individual",
            description: "You are a non business user of the site and are creating an account for non business purposes."
        }
    },
    subscriptions: {
        title: "Subscriptions",
        purchaseTitle: "Purchase a Subscription",
        subscriptionsFor: function anonymous(arg0) {
            return "For \"".concat(arg0, "\"");
        },
        purchaseSummaryTitle: function anonymous(arg0) {
            return "Purchase \"".concat(arg0, "\"");
        },
        availableSubscriptions: "Available Subscriptions",
        userSubscriptionsTitle: "Your subscriptions",
        noUserSubscriptions: "You do not have any subscriptions.",
        emptyList: "No subscriptions found.",
        loadError: "Unable to load subscriptions.",
        purchaseError: "There was an error purchasing this subscription.",
        requestApprovalError: "There was an error requesting approval to purchase this subscription.",
        vehicleLookup: function anonymous(arg0) {
            return "To see subscription options for a specific model, model year, or vehicle, please [lookup that vehicle](".concat(arg0, ") first.");
        },
        viewingVinOnly: function anonymous(arg0, arg1) {
            return "You are purchasing a subscription for a single VIN only: [".concat(arg0, "](").concat(arg1, ")");
        },
        noSingleVehicleSubscriptions: function anonymous(arg0) {
            return "There are no single vehicle subscriptions available to purchase for this vehicle. [You can search for and purchase alternative subscriptions.](".concat(arg0, ")");
        },
        taxNote: "**Note:** The tax amount is calculated based on your country and business status in accordance with EU laws.",
        orderSummaryTitle: "Order Summary",
        orderSummaryDescription: "Please review the subscription details and complete the requested information below.",
        approvalRequiredTitle: "Approval Required",
        approvalRequiredDescription: "Approval is required before you can purchase this subscription.",
        requestApprovalButton: "Request Approval",
        approvalRequestSentTitle: "Approval Request Sent",
        approvalRequestSentDescription: "A request for approval to purchase this subscription has been sent. Please wait for confirmation of approval or notification that more information is required before approval can be granted.",
        billingInfoTitle: "Billing Information",
        billingInfoDescription: "The following information is required to authorize payment. This information will be shared with Global Payments for the purpose of authorising your payment. To ensure that your payment is successful, please ensure that this information is the same as that held by your bank.",
        continueToPaymentTitle: "Continue to Payment",
        continueToPaymentDescription: "To complete your transaction you will be redirected to Global Payments secure payment site. You will return to this site once your transaction is complete.",
        continueToPaymentButton: "Continue to Payment",
        whatsIncluded: "What's included?",
        includedTitle: "Included in this subscription",
        includesAllDocuments: "This subscription includes access to all applicable documents.",
        includesService: "This subscription provides access to the specified service.",
        purchaseButton: "Purchase",
        generateInvoiceButton: "Generate Invoice",
        purchaseSuccessful: "Purchase Successful",
        purchaseFailed: "Purchase Failed",
        orderDetails: "Order Details",
        orderHelpTitle: "Help and support",
        successfulOrderHelpText: function anonymous(arg0, arg1) {
            return "If you have a problem or query regarding your order, please [contact us](".concat(arg0, ") and supply your order number (").concat(arg1, ").");
        },
        failedOrderHelpText: function anonymous(arg0, arg1, arg2) {
            return "If you have a problem or query regarding your order, please [contact us](".concat(arg0, ") and supply your order number (").concat(arg1, ") and status code (").concat(arg2, ").");
        },
        nameLabel: "Name",
        scopeLabel: "Scope",
        periodLabel: "Period",
        vinLabel: "VIN",
        modelNameLabel: "Model",
        productYearLabel: "Product Year",
        issuedLabel: "Issued",
        expiresLabel: "Expires",
        priceLabel: "Price (incl. Tax)",
        offeredByLabel: "Offered By",
        active: "Active",
        inactive: "Inactive",
        expired: "Expired",
        awaitingApproval: "Awaiting Approval",
        awaitingPayment: "Awaiting Payment",
        rejected: "Rejected",
        addressLength: function anonymous(arg0) {
            return "Address must be a maximum of ".concat(arg0, " characters.");
        },
        townLength: function anonymous(arg0) {
            return "Town or city must be a maximum of ".concat(arg0, " characters.");
        },
        postCodeLength: function anonymous(arg0) {
            return "Post code must be a maximum of ".concat(arg0, " characters.");
        },
        phoneLength: function anonymous(arg0) {
            return "Telephone must be a maximum of ".concat(arg0, " digits.");
        },
        callingCodeLabel: "Calling code",
        callingCodeRequired: "Calling code is required.",
        scopes: {
            all: "All",
            model: "Product Related",
            singleModelYear: "Single Model Year"
        },
        periods: {
            all: "All",
            oneHour: "1 Hour",
            oneDay: "1 Day",
            oneWeek: "1 Week",
            thirtyDays: "30 Days",
            oneYear: "1 Year",
            indefinite: "Indefinite"
        },
        payment: {
            approved: "Thank you for purchasing your subscription. Your order was successful and your subscription has been activated.",
            declined: "Global Payments reports that your transaction was declined. This may be due to invalid information such as an invalid card number or expiration date. Your account has not been charged.",
            referral: "Global Payments has placed your transaction in a referral state, please contact your bank.",
            cardLostOrStolen: "Global Payments reports that your card is registered as lost or stolen, please contact your bank. You have not been charged for this transaction.",
            rejected: "We are sorry to inform you that your order was rejected by Global Payments automated fraud protection service. This can happen if your card has been declined 3 times in the last 24 hours. You will not be able to use this card to purchase a subscription for a further 24 hours.",
            invalidConfiguration: "Your order was unsuccessful due to a technical fault. Your account has not been charged and the system administrators have been notified about the fault.",
            notPermitted3dSecure: "Your transaction was not permitted due to a 3D Secure issue."
        }
    },
    subscription: {
        loadError: "Unable to load this subscription.",
        notFound: "Subscription not found.",
        alreadyPurchased: "You have already purchased this subscription.",
        cannotPurchase: "You cannot purchase this subscription.",
        purchaseButton: "Purchase This Subscription"
    },
    help: {
        title: "Help",
        noHelp: "No help is associated with this page.",
        loadError: "There was an error loading help."
    },
    table: {
        select: "Select",
        selectAll: "Select All",
        selectNone: "Select None",
        clearSort: "Clear Sort"
    },
    searchBox: {
        clear: "Clear",
        suggestions: {
            search: "Search",
            setInput: "Set Input"
        }
    },
    buttonBar: {
        overflowButtonTitle: "More Actions"
    },
    pagination: {
        range: function anonymous(arg0, arg1, arg2) {
            return "".concat(arg0, "-").concat(arg1, " of ").concat(arg2);
        },
        previousPage: "Previous Page",
        nextPage: "Next Page"
    },
    sort: {
        textAscending: "A to Z",
        textDescending: "Z to A",
        numberAscending: "lowest to highest",
        numberDescending: "highest to lowest",
        dateAscending: "oldest to newest",
        dateDescending: "newest to oldest"
    },
    language: {
        changeLanguageTitle: "Choose Language",
        changeCountryTitle: "Choose Location",
        errorChangingLanguage: "There was an error changing the language.",
        errorChangingCountry: "There was an error changing the country.",
        cannotChangeCountry: "You are not allowed to change your country.",
        unknownLanguage: "Unknown Language",
        unknownCountry: "Unknown Country",
        languageCode: function anonymous(arg0, arg1) {
            return "".concat(arg0, " (").concat(arg1, ")");
        }
    },
    legal: {
        privacyPolicy: "Privacy Policy",
        termsAndConditions: "Terms and Conditions",
        cookiePolicy: "Cookie Policy",
        documentLoadError: "Unable to display this document",
        errorCheckingTerms: "There was an error checking the Terms and Conditions agreement. Please try again.",
        termsChanged: "Our Terms and Conditions have been updated. Please read them and click \"I Agree\" in order to continue using this site.",
        termsAgreeButton: "I Agree",
        termsDisagreeButton: "I Do Not Agree, Please Delete My Data",
        termsSaveButton: "Save Changes",
        termsAgreeMessage: "I have read and agree to the terms and conditions.",
        privacyAgreeMessage: function anonymous(arg0) {
            return "I have read and agree to the [privacy policy](".concat(arg0, ").");
        },
        disagreeConfirmTitle: "Disable Account",
        disagreeConfirmMessage: "Are you sure? Your account will be disabled with immediate effect.",
        disagreeConfirmButton: "Disable Account",
        cookie: {
            details: "Cookie Settings",
            cookieAgreeButton: "Accept All Cookies",
            para1: "We use a number of different cookies on our site. If you do not know what cookies are, or how to control or delete them, then we recommend you visit [aboutcookies.org](http://www.aboutcookies.org) for detailed guidance.",
            para2: "We use cookies to enable website functionality. We also use cookies to analyse usage of our services.",
            para3: function anonymous(arg0) {
                return "There is a list of cookies used and a description of what each does in the [Privacy & Cookie Policy](/privacy).";
            },
            preference: {
                newRelic: "Allow information about my usage of this site to be collected and reported by New Relic for analytics purposes"
            }
        },
        termsApprovalRequired: "Approval Required"
    },
    browser: {
        incompatibleBrowserTitle: "Browser Not Supported",
        incompatibleBrowserMessage: "Sorry, your web browser is not currently supported by H-D Service Information Portal. Please upgrade your browser to one of the following:",
        outdatedMessage: "Your browser is out of date. Update your browser to ensure the best experience when using this site.",
        seeSupportedBrowsers: "See Supported Browsers",
        supportedBrowsersTitle: "Supported Browsers",
        supportedBrowsersMessage: "Update your browser to one of the following to ensure the best experience when using this site:",
        supportedBrowsers: {
            chrome: "Google Chrome (84 or later)",
            firefox: "Mozilla Firefox (83 or later)",
            safari: "Safari (11 or later, by upgrading macOS)",
            edge: "Microsoft Edge (86 or later)"
        }
    },
    exception: {
        title: "Error",
        message: "An error has occurred.",
        restartButton: "Restart"
    },
    buttons: {
        ok: "OK",
        cancel: "Cancel",
        open: "Open",
        close: "Close",
        tryAgain: "Try Again",
        back: "Back",
        hide: "Hide",
        expand: "Expand",
        collapse: "Collapse",
        continue: "Continue",
        undo: "Undo",
        send: "Send",
        clear: "Clear",
        print: "Print",
        download: "Download"
    },
    errors: {
        title: "An error has occurred",
        unexpected: "Sorry, an unexpected error has occurred. This may be a temporary issue, so please retry in a moment.",
        pageNotFound: "Page not found",
        offline: "You are offline",
        viewPage: "Unable to view this page.",
        viewPageOffline: "Unable to view this page as you are offline.",
        performActionOffline: "Unable to perform this action as you are offline."
    },
    misc: {
        loading: "Loading",
        forceSelectingCountry: "You must select a country to continue.",
        chooseRegionOrState: "Choose region or state"
    },
    definitionList: {
        copyError: "An error occurred while copying the value.",
        copySuccess: function anonymous(arg0) {
            return "".concat(arg0, " copied to clipboard");
        },
        copyTitle: function anonymous(arg0) {
            return "Copy ".concat(arg0);
        }
    },
    qrCode: {
        generateQrCode: "Generate QR Code",
        qrCode: "QR Code",
        generateForVehicle: "Generate a QR code for this vehicle:",
        generateForDocument: "Generate a QR code for this document:",
        label: "Label",
        format: "Format",
        png: "PNG",
        svg: "SVG",
        size: "Size",
        size256: "256px",
        size512: "512px",
        size1024: "1024px",
        size2048: "2048px",
        equivalentSize: function anonymous(arg0, arg1) {
            return "Equivalent to ".concat(arg0, "mm at ").concat(arg1, "dpi");
        },
        includeDomain: "Include domain",
        includeLogo: "Include logo",
        withFrame: "With frame",
        useModelInstead: "Use model instead?",
        useVinInstead: "Use VIN instead?"
    },
    __iwaStrings: true
};
